module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAlElEQVR4AaWSIQ5CMRBEqxGcgYPgMRzkS07wj0W4BpvgSHC/SRfwVQMjxiBIGcSYdufttrPl3IBB9bdOkZjiju3lgc0NWI0AKk3XJ9a7w758qnztmJjZRcXjgMTCMVX0EyAagu/jpQOoMjuArrE9QGLmgQdILPxtG8CcHbMAnUtiAyJxdM0CTH8BFJ0N0OLYAMXn6gUmjrkEhJi7kAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/meBubble.png
// module id = 8/18
// module chunks = 1